// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2of2t","legacyBtn":"MutateMid_legacyBtn__3ZFfV"};